import React from 'react';

import { ExecutionStatusLozenge } from '@qality/common-components/src/atoms/ExecutionStatusLozenge';
import { Text } from '@qality/common-components/src/atoms/Text';
import { ExecutionStatusSummary } from '@qality/common-model';

import { ExecutionStatusSummarySingleBarChart } from '../ExecutionStatusSummarySingleBarChart';
import {
  ContainerStyled,
  GridWrapperStyled,
  TextStyled,
} from './ExecutionStatusSummaryMultiBarChart.styled';

type Props = {
  statusSummary: ExecutionStatusSummary;
  title?: string;
  showProgressBars?: boolean;
};

export function ExecutionStatusSummaryMultiBarChart({
  statusSummary,
  title,
  showProgressBars = false,
}: Props): JSX.Element {
  return (
    <ContainerStyled>
      {title && <Text>{title}</Text>}
      <GridWrapperStyled showProgressBars={showProgressBars}>
        {[...statusSummary]
          .sort((a, b) => a.status.position - b.status.position)
          .map((statusInSummary) => (
            <React.Fragment key={statusInSummary.status.id}>
              <ExecutionStatusLozenge status={statusInSummary.status} />
              {showProgressBars && (
                <ExecutionStatusSummarySingleBarChart
                  statusInSummary={statusInSummary}
                />
              )}
              <TextStyled>
                {statusInSummary.percent.toFixed(2)}% ({statusInSummary.total})
              </TextStyled>
            </React.Fragment>
          ))}
      </GridWrapperStyled>
    </ContainerStyled>
  );
}
